import React, { useEffect, useState } from "react";
import { Icon } from "./icons";
import "./ManageGallery.css";

/* ✅ CLOUD BACKEND */
const API = "https://backend-9i6n.onrender.com";

const ManageGallery = () => {
  const [images, setImages] = useState([]);
  const [file, setFile] = useState(null);
  const [caption, setCaption] = useState("");
  const [loading, setLoading] = useState(false);
  const [deletingId, setDeletingId] = useState(null);

  /* ===== POPUP ===== */
  const [popup, setPopup] = useState({
    show: false,
    message: "",
    type: "success", // success | error
  });

  const token = localStorage.getItem("token");

  /* ===== POPUP HANDLER ===== */
  const showPopup = (message, type = "success") => {
    setPopup({ show: true, message, type });
    setTimeout(() => {
      setPopup({ show: false, message: "", type: "success" });
    }, 1800);
  };

  /* ===== FETCH IMAGES ===== */
  const fetchImages = async () => {
    try {
      const res = await fetch(`${API}/api/gallery`);
      const data = await res.json();
      setImages(Array.isArray(data) ? data : []);
    } catch {
      showPopup("गॅलरी लोड करता आली नाही", "error");
    }
  };

  useEffect(() => {
    fetchImages();
  }, []);

  /* ===== UPLOAD IMAGE ===== */
  const uploadImage = async (e) => {
    e.preventDefault();

    if (!file) {
      showPopup("कृपया छायाचित्र निवडा", "error");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("image", file);
    formData.append("caption", caption);

    try {
      await fetch(`${API}/api/gallery`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      setFile(null);
      setCaption("");
      fetchImages();
      showPopup("छायाचित्र यशस्वीरित्या अपलोड केले", "success");
    } catch {
      showPopup("अपलोड अयशस्वी झाले", "error");
    } finally {
      setLoading(false);
    }
  };

  /* ===== DELETE IMAGE ===== */
  const deleteImage = async (id) => {
    if (!window.confirm("हे छायाचित्र नक्की हटवायचे आहे का?")) return;

    setDeletingId(id);
    try {
      await fetch(`${API}/api/gallery/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });

      fetchImages();
      showPopup("छायाचित्र यशस्वीरित्या हटवले", "success");
    } catch {
      showPopup("हटवणे अयशस्वी झाले", "error");
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <div className="admin-page">
      <div className="gp-page-head">
        <div>
          <h1>छायाचित्र दालन</h1>
          <p>गावातील कार्यक्रम व उपक्रमांची छायाचित्रे व्यवस्थापित करा</p>
        </div>
      </div>

      {/* ===== UPLOAD FORM ===== */}
      <div className="gp-card gallery-form-card">
        <h3 className="gallery-form-title">नवीन छायाचित्र अपलोड करा</h3>
        <form onSubmit={uploadImage} className="gallery-form-grid">
          <input
            className="gp-input"
            type="file"
            accept="image/*"
            onChange={(e) => setFile(e.target.files[0])}
            required
          />
          <input
            className="gp-input"
            type="text"
            placeholder="मथळा (caption)"
            value={caption}
            onChange={(e) => setCaption(e.target.value)}
          />
          <button type="submit" className="gp-btn gp-btn-green" disabled={loading}>
            {loading ? (
              <span className="gp-spinner" />
            ) : (
              <>
                <Icon.upload size={16} /> अपलोड करा
              </>
            )}
          </button>
        </form>
      </div>

      {/* ===== GALLERY GRID ===== */}
      {images.length === 0 ? (
        <div className="gp-empty" style={{ marginTop: 22 }}>
          अद्याप कोणतीही छायाचित्रे अपलोड केलेली नाहीत
        </div>
      ) : (
        <div className="gallery-grid" style={{ marginTop: 22 }}>
          {images.map((img) => (
            <div key={img._id} className="gp-card gp-card--hover gallery-item">
              <div className="gallery-item-img">
                <img src={img.image} alt={img.caption || "Gallery"} loading="lazy" />
              </div>
              <div className="gallery-item-foot">
                <p>{img.caption || "—"}</p>
                <button
                  className="gp-icon-btn gp-icon-btn-danger"
                  title="हटवा"
                  onClick={() => deleteImage(img._id)}
                  disabled={deletingId === img._id}
                >
                  {deletingId === img._id ? (
                    <span className="gp-spinner gp-spinner-dark" />
                  ) : (
                    <Icon.trash size={15} />
                  )}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ===== TOAST ===== */}
      {popup.show && (
        <div className={`gp-toast gp-toast-${popup.type === "error" ? "error" : "success"}`}>
          <span>{popup.type === "success" ? "✅" : "❌"}</span>
          <p style={{ margin: 0 }}>{popup.message}</p>
        </div>
      )}
    </div>
  );
};

export default ManageGallery;
